<template>
  <div class="finance-btn-group">
    <!-- 结算列表-->
    <template v-if="sourceView===sourceViews.manageList">
      <el-button type="primary" @click="hp._view.showDetailView4Manage(undefined,true)">{{ $t('CargoMsg.Cargo_View') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_batchAudit'])" type="primary" @click="hp.batchAuditClickHandler()">{{ $t('CargoMsg.Cargo_BatchAudit') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_checkChange']) && hp.isCommittedAllowAddCost" type="primary" @click="hp.batchCheckChangeClickHandler()">{{ $t('FinanceManage.finance_batchCheckChange') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_lockJob'])" type="success" @click="hp.lockJobsClickHandler()">{{ $t('CargoMsg.Cargo_LockTheBill') }}</el-button>
      <el-button type="primary" @click="hp._view.showBusinessCommission=true">{{ $t('CargoMsg.Cargo_BusinessCommission') }}</el-button>
      <el-button type="primary" @click="hp.printClickHandler()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
      <el-button type="primary" @click="hp.exportExcelAllClickHandler()">{{ $t('CargoMsg.Cargo_exportExcelAll') }}</el-button>
      <el-button v-show="$checkPermission(['button_financeModule_updateBusinessDate'])" type="primary" @click="hp.updateBusinessDateClickHandler()">{{ $t('CargoMsg.Cargo_UpdateBusinessDate') }}</el-button>
    </template>
    <!-- 业务提成-->
    <template v-else-if="sourceView===sourceViews.businessCommission">
      <el-button type="primary" @click="hp._view.showDetailView4Business(undefined,true)">{{ $t('CargoMsg.Cargo_View') }}</el-button>
      <el-button v-show="$checkPermission(['button_ACPayAuth_provisioned'])" type="primary" @click="hp.provisionedClickHandler()">{{ $t('CargoMsg.Cargo_Accrue') }}</el-button>
      <el-button type="primary" @click="hp._view.backManageList">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
    </template>
    <!-- 详情-->
    <template v-else-if="sourceView===sourceViews.detail">
      <el-button type="primary" @click="hp._view.toBackList">{{ $t('CargoMsg.Cargo_ReturnQuery') }}</el-button>
      <template v-if="!detailFromFinanceManage">
        <el-button v-show="$checkPermission(['button_ACPayAuth_provisioned'])" type="primary" @click="hp.provisionedClickHandler()">{{ $t('CargoMsg.Cargo_Accrue') }} </el-button>
      </template>
      <template v-if="detailFromFinanceManage">
        <!-- 结转详情-可操作的 -->
        <el-button v-show="$checkPermission(['button_ACPayAuth_lockJob'])" type="success" @click="hp.lockJobsClickHandler()">{{ $t('CargoMsg.Cargo_LockTheBill') }}</el-button>
        <!--CARGO-6317 财务审核-基本详情页签去除导出全部控件-->
        <!--<el-button type="danger" @click="hp.exportExcelAllClickHandler()">导出全部</el-button>-->
        <el-button v-show="$checkPermission(['button_financeModule_audit'])" type="primary" :disabled="!enabledCheckBtn" @click="hp.auditClickHandler()">{{ $t('CargoMsg.Cargo_Audit') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_cancelAudit'])" type="primary" :disabled="!enabledCancelCheckBtn" @click="hp.cancelAuditClickHandler()">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
        <el-button v-show="hp.isChargeSubmitDirect" type="primary" :disabled="!$checkPermission(['button_financeModule_chargeAudit'])" @click="hp.chargeAuditClickHandler()">{{ $t('CargoMsg.Cargo_ChargesAudit') }}</el-button>
        <el-button v-show="hp.isChargeSubmitDirect" type="primary" :disabled="!$checkPermission(['button_financeModule_cancelChargeAudit'])" @click="hp.cancelChargesAuditClickHandler()">{{ $t('CargoMsg.Cargo_CancelTheChargesAudit') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_allowChange']) && hp.isCommittedAllowAddCost" :disabled="!enabledCancelChargeCheckBtn" type="primary" @click="hp.allowChangeClickHandler()">{{ $t('FinanceManage.finance_allowChange') }}</el-button>
        <!--        改单审核-->
        <el-button v-show="$checkPermission(['button_financeModule_checkChange']) && hp.isCommittedAllowAddCost" :disabled="!enabledChargeCheckBtn" type="primary" @click="hp.checkChangeClickHandler()">{{ $t('FinanceManage.finance_checkChange') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_revokeChangeCommit']) && hp.isCommittedAllowAddCost" :disabled="!enabledChargeCheckBtn" type="primary" @click="hp.btnRevokeChangeCommit_clickHandler()">{{ $t('FinanceManage.finance_revokeChangeCommit') }}</el-button>
        <el-button type="primary" :disabled="enabledPrintBtn" @click="hp.printHandler()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
        <el-button type="primary" @click="hp.profitPrintClickHandler()">{{ $t('CargoMsg.Cargo_PrintTheProfit') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_accountingDate'])" type="primary" @click="hp.updateAccountingDateClickHandler()">{{ $t('CargoMsg.Cargo_EditFinancialDate') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_accountingDate'])" type="primary" @click="hp.updateChargeAccountingDateClickHandler()">{{ $t('CargoMsg.Cargo_EditChargeFinancialDate') }}</el-button>
        <el-button v-show="$checkPermission(['button_financeModule_businessAdjustment'])" type="primary" @click="hp.buissInfoClickHandler()">{{ $t('CargoMsg.Cargo_BusinessAdjustment') }}</el-button>
      </template>
      <!--      <el-button v-show="enabledCancelAccrualBtn" type="primary" :disabled="!enabledCancelAccrualBtn" @click="hp.cancelProvisionedClickHandler()">{{ $t('CargoMsg.Cargo_CancelAccrue') }}</el-button>-->
      <template v-if="detailFromFinanceManage">
        <!-- 财务审核详情-可操作的 -->
        <el-dropdown split-button type="primary" style="margin-left: 5px" @click="handelLogCommand()" @command="p=>{this.logCommand=p;handelLogCommand()}">{{ $t('CargoMsg.Cargo_LogRecord') }}<el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="businessAdjustLogDialog">{{ $t('CargoMsg.Cargo_BusinessAdjustmentLog') }}</el-dropdown-item>
          <el-dropdown-item command="businessStatusLogDialog">{{ $t('CargoMsg.Cargo_BusinessStatusChangeLog') }}</el-dropdown-item>
        </el-dropdown-menu>
        </el-dropdown>
      </template>
    </template>

    <!--批量审核-->
    <check-dialog v-if="showCheckDialog" ref="checkDialog" :page-date="adjustPageDate" :show-page-date="true" :visible.sync="showCheckDialog" :edit-approval-date="editApprovalDate" :is-editable="checkDialog.isEditable" :po-no="checkDialog.isEditable ? '' : checkDialog.poNo" @confirm="hp.batchAuditConfirmCB($event)" @returnDatePage="hp.cancelAdjustDate($event)" />
    <!--批量改单,改单审核-->
    <change-bill-dialog v-if="showChangeDialog" ref="changeDialog" :visible.sync="showChangeDialog" @confirm="hp.batchCheckChangeConfirmCB($event)" />
    <!--按业务日期审核--锁单-->
    <lock-order-dialog v-if="showLockOrderDialog" ref="lockOrderDialog" :visible.sync="showLockOrderDialog" @confirm="hp.lockOrderConfirmCB($event)" />
    <!--计提-->
    <provisioned-dialog v-if="showProvisionedDialog" ref="provisionedDialog" :info="{title:$t('CargoMsg.Cargo_Accrue'),label:$t('CargoMsg.RequiredAccrueDate')}" :disabled-after-today="false" :visible.sync="showProvisionedDialog" @confirm="hp.provisionedConfirmCB($event)" />
    <!--业务日期调整-->
    <business-date-dialog v-if="showBusinessDateDialog" ref="businessDateDialog" :info="{title:$t('CargoMsg.Cargo_UpdateBusinessDate'),label:$t('CargoMsg.Cargo_BusinessDate')}" :disabled-after-today="false" :visible.sync="showBusinessDateDialog" @confirm="hp.updateBusinessDateConfirmCB($event)" />

    <!--    业务调整-->
    <business-adjust-dialog v-if="showBusinessAdjustDialog" :visible.sync="showBusinessAdjustDialog" :job="job" @confirm="hp.buissInfoClickHandlerConfirmCB($event)" />
    <!--业务调整日志-->
    <business-adjust-log-dialog :visible.sync="showBusinessAdjustLogDialog" :job="job" />
    <!--业务状态变更日期 -->
    <business-status-log-dialog v-if="showBusinessStatusLogDialog" :visible.sync="showBusinessStatusLogDialog" :job-uuid="job.uuid||''" />
    <!-- 费用审核-->
    <charge-check-dialog v-if="showChargeCheckDialog" :visible.sync="showChargeCheckDialog" :info="{ title: $t('CargoMsg.Cargo_EditFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" @confirm="hp.chargeAuditConfirmCB($event)" />
    <!-- 修改财务日期-->
    <update-accounting-date-dialog v-if="showUpdateAccountingDateDialog" :page-date="accountingPageDate" :show-page-date="true" :info="{ title: $t('CargoMsg.Cargo_EditFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" :visible.sync="showUpdateAccountingDateDialog" @returnDatePage="hp.cancelAccountingDate($event)" @confirm="hp.updateAccountingDateConfirmCB($event)" />
    <!-- 修改费用财务日期-->
    <update-charge-accounting-date-dialog v-if="showUpdateChargeAccountingDateDialog" :info="{ title: $t('CargoMsg.Cargo_EditChargeFinancialDate'), label: $t('CargoMsg.Cargo_FinancialDate') }" :visible.sync="showUpdateChargeAccountingDateDialog" @confirm="hp.updateChargeAccountingDateConfirmCB($event)" />
    <!-- 财务审核 审核弹框-->
    <checking-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :lob="job.lob"
      :job="job"
      :check-node="checkingWindow.checkNode"
      :call-back="checkingWindow.callBack"
      :call-back2="checkingWindow.callBack2"
      @returnCallBack="returnCallBack"
    />
    <!-- 财务审核 批量审核弹框 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      ref="batchCheckingWindow"
      :visible.sync="batchCheckingWindow.visible"
      :allow-partial-check-pass="batchCheckingWindow.allowPartialCheckPass"
      :lob="'all'"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      @returnCallBack="batchReturnCallBack"
    />
  </div>
</template>
<script>

import AbstractClosingAccount from './AbstractClosingAccount'

import checkDialog from './cACheckDialog'
import chargeCheckDialog from './cAChangeDialog'
import changeBillDialog from './cAChangeDialog'
import provisionedDialog from './cAChangeDialog'
import cancelProvisionedDialog from './cAChangeDialog'
import updateAccountingDateDialog from './cAChangeDialog'
import updateChargeAccountingDateDialog from './cAChangeDialog'
import businessDateDialog from './cAChangeDialog'
import lockOrderDialog from './cALockOrderDialog'
import businessAdjustDialog from './cABusinessAdjustDialog'
import businessAdjustLogDialog from './cABusinessAdjustLogDialog'
import businessStatusLogDialog from './cABusinessStatusLogDialog'
import checkingWindow from '@/components/Cargo/Job/CheckingManager/CheckingWindow'
import batchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

const manageList = 'manageList' // 财务审核
const businessCommission = 'businessCommission'// 业务提成
const detail = 'detail' // 详情
export default {
  name: 'ClosingAccountBtnGroup',
  components: { checkDialog, chargeCheckDialog, updateAccountingDateDialog, updateChargeAccountingDateDialog,
    cancelProvisionedDialog, changeBillDialog, provisionedDialog, businessDateDialog, lockOrderDialog,
    businessAdjustDialog,
    businessAdjustLogDialog,
    businessStatusLogDialog, checkingWindow, batchCheckingWindow },
  props: {
    sourceView: { type: String, default: 'manageList', validator: (value) => { return [manageList, businessCommission, detail].includes(value) } }, //
    job: { type: Object },
    hp: { type: Object, required: true, validator: (value) => value instanceof AbstractClosingAccount },
    activeTabName: { type: String, required: false, default: 'basic' }
  },
  data() {
    return {
      showBusinessAdjustDialog: false,
      showBusinessAdjustLogDialog: false,
      showUpdateAccountingDateDialog: false,
      showUpdateChargeAccountingDateDialog: false,

      showBusinessStatusLogDialog: false,
      showChargeCheckDialog: false,
      accountingPageDate: new Date(), // 修改财务日期 记录用户上次选择的时间
      adjustPageDate: new Date(), // 审核 记录用户上次选择的时间
      showCheckDialog: false,
      editApprovalDate: false,
      batchShowCheckDialog: false,
      checkDialog: {
        isEditable: false,
        poNo: ''
      },
      showChangeDialog: false,
      showLockOrderDialog: false,
      showProvisionedDialog: false,
      showCancelProvisionedDialog: false,
      showBusinessDateDialog: false,
      showAccrualDialog: false,
      showCancelAccrualDialog: false,
      sourceViews: {
        manageList,
        detail,
        businessCommission
      },
      checkingWindow: {
        visible: false,
        checkNode: 13,
        callBack: null,
        callBack2: null
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        allowPartialCheckPass: false,
        checkNode: 13,
        callBack: null,
        callBack2: null
      },
      logCommand: 'businessAdjustLogDialog',
      enabledPrintBtn: false // 控制打印按钮是否可用
    }
  },
  computed: {
    detailFromFinanceManage() { // 来源于财务审核主列表
      return this.hp._view.viewSource === 'manageList'
    },
    enabledChargeCheckBtn() {
      // 改单审核：业务状态：已审核；改单状态：改单提交
      return this.job && this.job.jobState === SystemConstants.STATE_VERIFIED.code && this.job.changeState === SystemConstants.CHANGE_COMMIT.code
    },
    enabledCancelChargeCheckBtn() {
      // 允许改单：业务状态：已审核；改单状态：不可改单、改单审核
      return (this.job && this.job.jobState === SystemConstants.STATE_VERIFIED.code && (this.job.changeState === SystemConstants.CHANGE_CANNOTCHANGE.code || this.job.changeState === SystemConstants.CHANGE_AUDIT.code))
    },
    enabledAccrualBtn() {
      return this.job && (!this.job.provisioned) && this.$checkPermission(['button_ACPayAuth_provisioned'])
    },
    enabledCancelAccrualBtn() {
      return this.job && this.job.provisioned && this.$checkPermission(['button_ACPayAuth_awayProvisioned'])
    },
    enabledCheckBtn() {
      return this.job && this.job.jobState === 1
    },
    enabledCancelCheckBtn() {
      if (this.job && this.job.jobState === 2) {
        if (this.hp.isCommittedAllowAddCost) {
          if (this.job.changeState === SystemConstants.CHANGE_CANNOTCHANGE.code || this.job.changeState === SystemConstants.CHANGE_AUDIT.code) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  watch: {
    activeTabName(newVal) {
      if (newVal) {
        this.enabledPrintBtn = newVal === 'tabVesselEq' || newVal === 'tabCharges' || newVal === 'tabAdvanceCharge'
      }
    }
  },
  beforeMount() {
    // 将该控件进行注入
    this.hp.cABtnGroupView = this
    this.hp.checkingWindow = this
    this.hp.batchCheckingWindow = this
  },
  methods: {
    handelLogCommand() {
      if (this.logCommand === 'businessAdjustLogDialog') {
        this.showBusinessAdjustLogDialog = true
      }
      if (this.logCommand === 'businessStatusLogDialog') {
        this.showBusinessStatusLogDialog = true
      }
    },
    returnCallBack(showCheckDialog) {
      this.checkDialog.poNo = this.job.poNo
      this.checkDialog.isEditable = false
      this.showCheckDialog = showCheckDialog
    },
    batchReturnCallBack(batchShowCheckDialog) {
      this.checkDialog.isEditable = batchShowCheckDialog
      this.showCheckDialog = batchShowCheckDialog
    },
    refresh() {
      this.hp.refresh()
    }
  }
}
</script>

<style scoped lang="scss">
  .finance-btn-group{
  }
</style>
